import React, {useEffect, useState, forwardRef} from 'react';
import get from 'lodash.get';
import useGetFiles from 'hooks/useGetFiles';
import axios from 'axios';
import LoadingPage from 'components/LoadingPage';
import PDFPreview from 'components/files/pdf/Preview';

const SignedAsset = forwardRef(({asset, showControls, ...props}, ref) => {
    // const axios = useGetAxiosClient();
    const [statefulAsset, setStatefulAsset] = useState(asset);
    const [refresh, setRefresh] = useState([]);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const {refetch} = useGetFiles(refresh);
    const isPDF = statefulAsset?.document_filename?.split('.').pop().toLowerCase() === 'pdf';

    useEffect(() => {
        setStatefulAsset(asset);
    }, [asset]);

    // Catch 400 failures and push to refresh tracker to use
    // file api to obtain new signed url
    useEffect(() => {
        const setAssetData = setData;

        if (statefulAsset) {
            axios
                .get(statefulAsset?.signed_url, {
                    responseType: 'blob',
                })
                .then(response => {
                    const reader = new FileReader();
                    reader.onload = () => {
                        setAssetData(reader.result);
                    };
                    reader.readAsDataURL(response.data);
                })
                .catch(e => {
                    // Old signed url, let's refresh
                    if (e.status === 400 || e.message === 'Network Error') {
                        setRefresh([statefulAsset.id]);
                    }
                });
        }
    }, [statefulAsset]);

    // Trigger fetch cycle once hook resolves
    useEffect(() => {
        if (refresh.length) {
            setLoading(true);
            refetch()
                .then(result => {
                    const newAsset = get(result, '[0].data');
                    setStatefulAsset(newAsset);
                    setRefresh([]);
                    setLoading(false);
                })
                .catch(e =>
                    console.error(
                        'Ran into an error refreshing signed asset',
                        e
                    )
                );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refresh]);

    return loading ? (
        <LoadingPage />
    ) : isPDF ? (
        <PDFPreview
            {...props}
            showControls={showControls}
            ref={ref}
            file={data}
        />
    ) : (
        // eslint-disable-next-line jsx-a11y/alt-text
        <img {...props} src={data} />
    );
});

export default SignedAsset;
